<div class="sign-up">
  <h2 class="sign-up__header">
    <b>{{ headerText }}</b>
  </h2>
  @if (isSuccess) {
    <div class="sign-up__success">
      <ng-container>
        <div class="sign-up__success--text">
          A verification email has been sent to your registered email address. Please verify by clicking the link to 'New Registration Form'.
        </div>
        <div class="sign-up__buttons">
          <button mat-raised-button class="sign-up__buttons--create" active (click)="startLogin()">Log in</button>
        </div>
      </ng-container>
    </div>
  } @else {
    <div class="sign-up__container">
      <ng-container>
        <div class="sign-up__content">
          <form [formGroup]="signUpFormGroup">
            <h2>
              <p>To use eLicensing or data.comreg.ie the following steps are required:</p>
            </h2>
            <div class="sign-up__content--text">
              <ol>
                <li>Create a login by entering your name and email address below.</li>
                <li>Following a confirmation message, a verification email will be sent to your registered email address.</li>
                <li>Follow the highlighted link.</li>
                <li>Complete and submit the 'New Registration Form'.</li>
                <li>Once approved by ComReg you can access your account.</li>
              </ol>

              <i>NB: If an account already exists, the account administrator can add your login to that account.</i>
            </div>
            <div class="sign-up__content--form">
              <mat-form-field class="sign-up__content--form--field">
                <mat-label>First Name</mat-label>
                <input matInput [formControl]="firstName" id="firstName" type="text" />
                <mat-error>Requried</mat-error>
              </mat-form-field>

              <mat-form-field class="sign-up__content--form--field--lastName">
                <mat-label>Last Name</mat-label>
                <input matInput [formControl]="lastName" id="lastName" type="text" />
                <mat-error>Requried</mat-error>
              </mat-form-field>

              <mat-form-field class="sign-up__content--form--field--email">
                <mat-label>Email Address</mat-label>
                <input matInput [formControl]="email" id="email" type="text" />
                <mat-error comFormMessageName="email" validation="required">Required</mat-error>
                <mat-error comFormMessageName="email" validation="pattern">The email format is incorrect</mat-error>
              </mat-form-field>

              <div class="sign-up__content--recaptcha">
                <re-captcha [siteKey]="siteId" formControlName="reCaptcha" id="reCaptcha"> </re-captcha>
              </div>

              @if (signUpFormGroup.dirty && reCaptcha.errors?.['required']) {
                <mat-error>Requried</mat-error>
              }

              @if (submissionError) {
                <div>There was an error creating the new account, please check your details and try again.</div>
              }

              <div class="sign-up__buttons">
                <button mat-raised-button class="button--secondary" active (click)="startLogin()">Back</button>
                <button mat-raised-button (click)="createNewLogin()" id="create-login">Create Log In</button>
              </div>
            </div>
          </form>
        </div>
      </ng-container>
    </div>
  }
</div>
